import { digestFreshness } from '@cerebro-diem/core';
import { errorMessage } from './errors';

/**
 * digestFreshness for display. An unreadable timestamp is shown as such (and
 * never as today's) instead of throwing during render, which would blank the
 * whole app, capture box included.
 */
export function digestAge(generatedAt: string, now: Date = new Date()): { isToday: boolean; label: string } {
  try {
    const { isToday, label } = digestFreshness(generatedAt, now);
    return { isToday, label };
  } catch (err) {
    return { isToday: false, label: `Generation time unreadable (${errorMessage(err)})` };
  }
}
